/**
 * 생육 데이터 조회 — 생육 분석 장비의 사진 · 3D 모델 · 초장 · 엽면적을 날짜별로 본다 (화면 = 3D 분석).
 *
 * 예전 '측정 기록' 탭은 3D 분석과 거의 같은 내용이라 없앴다 (2026-11-03). 장비 고르기는 그 탭의 농장별 드롭다운을 옮겨 썼다
 * (GrowthDeviceSelect — 장비가 많아도 한 줄).
 */
import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { DeviceInfo } from '@grosync/common';
import { AdminTopBar, ViewScroll } from '../../ui';
import { fetchDevices } from '../../api/devices';
import { fetchFarms } from '../../api/farms';
import { LoadingSpinner, PageError } from '../../components/LoadingSpinner';
import { Growth3dBody } from '../growth3d';

const TITLE = '생육 데이터 조회';
const SUBTITLE = '생육 분석 장비 · 사진 타임라인 · 3D 분석 측정값';

export default function GrowthView(): React.ReactElement {
  const devicesQ = useQuery({ queryKey: ['devices'], queryFn: fetchDevices });
  const farmsQ = useQuery({ queryKey: ['farms'], queryFn: fetchFarms });
  const growthDevices = useMemo<DeviceInfo[]>(
    () => (devicesQ.data ?? []).filter((d) => d.model === 2),
    [devicesQ.data],
  );

  return (
    <>
      <AdminTopBar title={TITLE} subtitle={SUBTITLE} />
      <ViewScroll gap={18}>
        {devicesQ.isLoading || farmsQ.isLoading ? (
          <LoadingSpinner />
        ) : devicesQ.isError || farmsQ.isError ? (
          <PageError message="데이터를 불러오지 못했습니다." />
        ) : (
          <Growth3dBody devices={growthDevices} farms={farmsQ.data ?? []} />
        )}
      </ViewScroll>
    </>
  );
}
